import React from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Countdown from 'react-countdown';
import ResourcesView from '../components/resources-view.js';
import config from './../config.js';

import * as Backend from "../backend.js";
import * as ICONS from "./icons.js";

const THOUSAND = 1000;
const MILLION = 1000 * THOUSAND;
const BILLION = 1000 * MILLION;

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const YEAR = 365 * DAY;

// ------------------------------------------------------------------------------------
// Global Player Shit
// Contains info that is updated rarely and therefore not send on each request
// It is set by the backend.js
// Edit: GPS is now updated frequently but still needed because its a global variable accessed by everyone now

let gps_listeners = [];
let gps_cache = undefined;

export const getGPS = () => {
    return gps_cache;
}

export const subscribeGPS = (id, listener) => {
    gps_listeners[id] = listener;
}

export const unsubscribeGps = (id) => {
    gps_listeners[id] = undefined;
}

export const updateGps = (gps) => {
    gps_cache = gps;
    for (let prop in gps_listeners) {
        if (gps_listeners.hasOwnProperty(prop) && gps_listeners[prop]) {
            gps_listeners[prop](gps);
        }
    }
}

// ------------------------------------------------------------------------------------
// Callback function set by `index.js`. Can be called to show a toast message.

export var toastHandler = { callback: null };

// ------------------------------------------------------------------------------------
// Some react components

export class GameComponent extends React.Component {
    constructor(props) {
        super(props);
        this.load_state = "STALE";
    }

    hasCurrentState(force) {
        if (force || this.load_state === "STALE") {
            this.refreshState();
            this.load_state = "PENDING";
            return false;
        }

        if (this.load_state === "FRESH") {
            this.load_state = "STALE";
            return true;
        }

        return false;
    }

    setState(state) {
        this.load_state = "FRESH";
        super.setState(state)
    }

    refreshState() {
        // Overwrite if needed
    }
}

// props = {planet: {name: "Earth", x: 1, y: 2, z: 3, owner_id: 123, owner_name: "EvilNet"}, linkToDetails: false}
export class PlanetLink extends React.Component {

    render() {
        let planet = this.props.planet;

        if (!planet) {
            return (<div>INVALID</div>);
        }

        let coords = (<div className="planet-coords">({planet.x}:{planet.y}:{planet.z})</div>);
        if (this.props.noCoords === true) {
            coords = undefined;
        }

        let url = '/game/galaxy-browser' + getPlanetUrl(planet);
        if (this.props.linkToDetails) {
            url = '/game/planet-construction' + getPlanetUrl(planet);
        }

        let owner;
        if (this.props.showOwner) {
            if (planet.owner_id) {
                owner = (
                    <div style={{ display: "inline", whiteSpace: "nowrap" }}>
                        <span> (</span>
                        <PlayerLink playerId={planet.owner_id} playerName={planet.owner_name} />
                        <span>)</span>
                    </div>
                );
            } else if (planet.name) {
                owner = (
                    <div style={{ display: "inline", whiteSpace: "nowrap" }}>
                        <span> (unowned)</span>
                    </div>
                );
            } else {
                owner = (
                    <div style={{ display: "inline", whiteSpace: "nowrap" }}>
                        <span> (empty space)</span>
                    </div>
                );
            }
        }

        return (
            <div style={{ display: "inline", whiteSpace: "nowrap" }}>
                <Link className="link-button"
                    to={{
                        pathname: url,
                        force_update: true
                    }}>{planet.name}
                </Link>
                {coords}
                {owner}
            </div>
        );
    }
}

export class PlanetInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = { planet: {} };
        this._refreshPlanetDetails(this.props.planet.x, this.props.planet.y, this.props.planet.z);
    }

    render() {
        let planet_html;

        if (this.state.planet.x !== this.props.planet.x || this.state.planet.y !== this.props.planet.y || this.state.planet.z !== this.props.planet.z) {
            planet_html = (<span>loading ..</span>);
        } else {
            if (this.state.planet.astro_info) {
                planet_html = (<PlanetLink planet={this.state.planet} showOwner={true} />);
            } else {
                planet_html = (<span>no planet here ..</span>);
            }
        }

        return (
            <div style={this.props.style}>
                <input value={this.props.planet.x}
                    onChange={(event) => this.handleUpdate("x", event)}
                    type="number"
                    style={{ width: "40px", }} />
                <span>:</span>
                <input value={this.props.planet.y}
                    onChange={(event) => this.handleUpdate("y", event)}
                    type="number"
                    style={{ width: "40px", }} />
                <span>:</span>
                <input value={this.props.planet.z}
                    onChange={(event) => this.handleUpdate("z", event)}
                    type="number"
                    style={{ width: "40px", }} />
                <span> -&#62; </span>
                {planet_html}
            </div>);
    }

    handleUpdate(coord, event) {
        let value = toNumberOrZero(event.target.value);
        let x = coord === "x" ? value : this.props.planet.x;
        let y = coord === "y" ? value : this.props.planet.y;
        let z = coord === "z" ? value : this.props.planet.z;

        this._refreshPlanetDetails(x, y, z);
        return this.props.onChange(x, y, z);
    }

    _refreshPlanetDetails(x, y, z) {
        Backend.getPlanetAbstract(x, y, z, (planet) => {
            // Has already changed
            if (this.props.planet.x !== planet.x || this.props.planet.y !== planet.y || this.props.planet.z !== planet.z) {
                return;
            }
            this.setState({ planet: planet });
        });
    }
}

export class PlayerLink extends React.Component {

    render() {
        let player_id = this.props.playerId;
        let player_name = this.props.playerName;

        if (player_id == null) {
            return (<div>--</div>);
        }

        return (
            <div style={{ display: "inline" }}>
                <Link className="link-button"
                    to={{
                        pathname: '/game/player-abstract/' + player_id,
                        force_update: true
                    }}>{player_name}
                </Link>
            </div>
        );
    }
}

export class ChatLink extends React.Component {
    render() {
        let chat_id = this.props.chat_id;
        let text = this.props.text;

        return (
            <div style={{ display: "inline" }}>
                <Link className="link-button"
                    to={{
                        pathname: '/game/chat/' + chat_id,
                        force_update: true
                    }}>{text}
                </Link>
            </div>
        );
    }
}

export class JsonDebug extends React.Component {
    constructor(props) {
        super(props);
        this.state = { minimized: true };
    }

    render() {
        let obj = this.props.obj;

        if (!config.debug) {
            return (<div />);
        }

        if (this.state.minimized) {
            return (<div className="action-button" style={{ float: "right" }} onClick={() => this._onToggle()}>show debug
            </div>);
        }

        return (
            <div>
                <h3>Debug</h3>
                <div className="action-button" style={{ float: "right" }} onClick={() => this._onToggle()}>hide debug
                </div>
                <br />
                <br />
                <pre>
                    {JSON.stringify(obj, null, 2)}
                </pre>
                {/*<ReactJson src={{"asd": "asd"}} theme="harmonic" enableClipboard={false} style={{background: "#111132"}}/>*/}
            </div>
        );
    }

    _onToggle() {
        this.setState({ minimized: !this.state.minimized });
    }
}

export class MessagePlayerLink extends React.Component {

    render() {
        let player_id = this.props.playerId;
        let player_name = this.props.playerName;

        if (player_id == null) {
            return (<div>--</div>);
        }

        return (
            <div style={{ display: "inline" }}>
                <Link className="link-button"
                    to={{
                        pathname: '/game/chat-compose/' + player_id,
                        force_update: true
                    }}>Message {player_name}
                </Link>
            </div>
        );
    }
}

export class FleetLink extends React.Component {

    render() {
        let fleet_id = this.props.fleetId;
        let fleet_name = this.props.fleetName;

        if (fleet_id == null) {
            return (<div>--</div>);
        }

        return (
            <div style={{ display: "inline" }}>
                <Link className="link-button" style={{ whiteSpace: "nowrap" }}
                    to={{
                        pathname: '/game/fleet/' + fleet_id,
                        force_update: true
                    }}>{fleet_name}
                </Link>
            </div>
        );
    }
}

export class FleetStatus extends React.Component {

    static getMoveStep(fleet) {
        return fleet.next_task.steps[0];
    }

    static getFleetStatus(fleet) {
        if (fleet.next_task == null) {
            return null;
        }
        const next_step = fleet.next_task.steps[0];
        return next_step.type;
    }

    render() {
        let fleet = this.props.fleet;
        const status = FleetStatus.getFleetStatus(fleet);

        if (status === null) {
            return "Orbiting";
        }

        switch (status) {
            case "LAND":
                return (<span>Landing</span>);
            case "LAUNCH":
                return (<span>Launching</span>);
            case "LOAD":
                return (<span>Loading resources</span>);
            case "MOVE":
                return (<span>Travelling</span>);
            case "COLONIZE":
                return (<span>Colonizing</span>);
            case "STATION":
                return (<span>Stationing</span>);
            case "RAID":
                return (<span>Raiding</span>);
            case "REPAIR":
                return (<span>Repairing</span>);
            default:
                return (<span>Unknown</span>);
        }
    }
}

export class LoadingBar extends React.Component {

    render() {
        let thing = this.props.thing;
        let thing_name = this.props.thingName;

        if (thing === undefined) {
            return (<div className="load-text"><p>Loading ... </p></div>);
        }
        if (thing === null) {
            return (<div><p>No {thing_name} here ..</p> <Link className="link-button-menu" to={{
                pathname: '/game/dashboard',
                force_update: true
            }}>Home</Link></div>);
        }
        return (<div><p>There is a {thing_name}, so I should not be displayed.</p></div>);
    }
}

export class LoadingBar2 extends React.Component {
    render() {
        return (<div className="load-text"><p>Loading ... </p></div>);
    }
}

export class Timer extends React.Component {
    render() {
        return (<Countdown date={this.props.date} {...this.props} renderer={(x) => {
            return this.renderer(x)
        }} />);
    }

    renderer({ days, hours, minutes, seconds, completed }) {
        if (completed) {
            if (this.props.ready)
                return <>{this.props.ready}</>;
            else
                return <span className="time-count-down" style={this.props.style}> Ready!</span>;
        } else {
            return <span className="time-count-down"
                style={this.props.style}>{RealTime.timeComponentsToHtml(days, hours, minutes, seconds)}</span>;
        }
    };
}

// Use style={display: "block"} to make it right align (like in construction menu)
export class TimeSpan extends React.Component {
    render() {
        return <span className="time-count-down"
            style={this.props.style}>{RealTime.timeSpanToHtml(this.props.timeSpan)}</span>;
    }
}

// Use style={display: "block"} to make it right align (like in construction menu)
export class NiceInlineTimeSpan extends React.Component {
    render() {
        if (!IsNumber(this.props.timeSpan)) {
            return (<span>Unknown</span>);
        }

        let time_components = RealTime.timeToTimeComponents(this.props.timeSpan);

        let html = [];
        if (time_components.days > 0) {
            html.push(<span key={0}>{time_components.days}</span>);
            html.push(<span key={1} className="boring-info-text">d</span>);
        }
        if (time_components.days > 0 || time_components.hours > 0) {
            html.push(<span key={2}>{time_components.hours}</span>);
            html.push(<span key={3} className="boring-info-text">h</span>);
        }
        if (time_components.days > 0 || time_components.hours > 0 || time_components.minutes > 0) {
            html.push(<span key={4}>{time_components.minutes}</span>);
            html.push(<span key={5} className="boring-info-text">m</span>);
        }
        html.push(<span key={6}>{time_components.seconds}</span>);
        html.push(<span key={7} className="boring-info-text">s</span>);

        return (<span>{html}</span>);
    }
}

export class Fuel extends React.Component {
    render() {
        return (
            <span>
                <span className="boring-info-text">Fuel: </span>
                <span>{this.props.fuel}</span>
            </span>
        );
    }
}

export class FuelEstimation extends React.Component {
    render() {
        if (this.props.fuel.isEnough()) {
            return (
                <div className="fuel-tooltip">
                    <img src={ICONS.FUEL_STATES.ok} alt={"Maybe enough Fuel"}
                        style={{ width: "32px", height: "32px", float: "left", margin: "4px" }} />
                    <div className="fuel-tooltiptext">
                        {"Fleet has enough fuel for this assignment."}
                    </div>
                </div>
            );
        }

        if (this.props.fuel.maybeEnough()) {
            return (
                <div className="fuel-tooltip">
                    <img src={ICONS.FUEL_STATES.maybe} alt={"Maybe enough Fuel"}
                        style={{ width: "32px", height: "32px", float: "left", margin: "4px" }} />
                    <div className="fuel-tooltiptext">
                        {"Only enough fuel, if all fueling assignments ahead work out. If fuel runs out, this and all further assignments are canceled."}
                    </div>
                </div>
            );
        }

        return (
            <div className="fuel-tooltip">
                <img src={ICONS.FUEL_STATES.no} alt={"Maybe enough Fuel"}
                    style={{ width: "32px", height: "32px", float: "left", margin: "4px" }} />
                <div className="fuel-tooltiptext">
                    {"The fleet does not have enough fuel for this assignment. It and all further assignments will be canceled."}
                </div>
            </div>
        );
    }
}

export class KeyCheckboxInput extends React.Component {
    render() {
        let pre_label_html;
        if (this.props.label) {
            pre_label_html = (<span>{this.props.label}: </span>);
        }

        let post_label_html;
        if (this.props.postLabel) {
            post_label_html = (<span> {this.props.postLabel}</span>);
        }

        return (
            <div style={this.props.style}>
                {pre_label_html}
                <input checked={this.props.value}
                    type="checkbox"
                    onChange={(event) => this.handleUpdate(event)}
                />
                {post_label_html}
            </div>);
    }

    handleUpdate(event) {
        let value = event.target.checked;
        this.props.onChange(value);
    }
}

export class KeyValueInput extends React.Component {
    constructor(props) {
        super(props);
        this.is_number = false;
    }

    render() {
        let width = this.props.width;
        if (!width) width = "auto";

        let is_good = true;
        let input_type = "text";
        let do_highlight = false;

        if (this.props.checks) {
            for (let check of this.props.checks) {
                switch (check) {
                    case "NOT_EMPTY": {
                        is_good &= this.props.value.length > 0;
                        break;
                    }
                    case "NUMBER": {
                        input_type = "number";
                        this.is_number = true;
                        break;
                    }
                    default: {
                        console.log("Unknown check: " + check);
                    }
                }
            }
        }

        if (this.is_number && this.props.maxValue) {
            is_good &= this.props.value <= this.props.maxValue;
        }

        let pre_label_html;
        if (this.props.label) {
            pre_label_html = (<span>{this.props.label}: </span>);
        }

        let post_label_html;
        if (this.props.postLabel) {
            post_label_html = (<span> {this.props.postLabel}</span>);
        }

        return (
            <span style={this.props.style}>
                {pre_label_html}
                <input value={this.props.value}
                    onChange={(event) => this.handleUpdate(event)}
                    type={input_type}
                    onFocus={(event) => {
                        if (do_highlight) event.target.select()
                    }}
                    style={{
                        width: width,
                        color: (is_good ? undefined : "red"),
                        borderColor: (is_good ? undefined : "red"),
                    }} />
                {post_label_html}
            </span>);
    }

    handleUpdate(event) {
        let value = event.target.value;
        if (this.is_number) {
            value = toNumberOrZero(value);
        } else {
            if (value.length > this.props.maxLength) {
                value = value.substring(0, this.props.maxLength);
            }
        }
        this.props.onChange(value);
    }
}

export class LabelValueInputTr extends React.Component {
    constructor(props) {
        super(props);
        this.is_number = false;
    }

    render() {
        let width = this.props.width;
        if (!width) width = "auto";

        let is_good = true;
        let input_type = "text";
        let do_highlight = false;

        if (this.props.checks) {
            for (let check of this.props.checks) {
                switch (check) {
                    case "NOT_EMPTY": {
                        is_good &= this.props.value.length > 0;
                        break;
                    }
                    case "NUMBER": {
                        input_type = "number";
                        this.is_number = true;
                        break;
                    }
                    default: {
                        console.log("Unknown check: " + check);
                    }
                }
            }
        }

        if (this.is_number && this.props.maxValue) {
            is_good &= this.props.value <= this.props.maxValue;
        }

        let pre_label_html;
        if (this.props.label) {
            pre_label_html = (
                <td style={{ width: (this.props.label_width ? this.props.label_width : undefined) }}>
                    {this.props.label + (this.props.colun ? ":" : "")}
                </td>);
        }

        let post_label_html;
        if (this.props.postLabel) {
            post_label_html = (<td>{this.props.postLabel}</td>);
        }

        let value_html;
        if (this.props.editable) {
            if (this.props.area) {
                value_html = (<textarea maxLength="100000"
                    rows="15"
                    //cols="50"
                    placeholder="background story"
                    value={this.props.value}
                    onChange={(event) => this.handleUpdate(event)}
                    onFocus={(event) => {
                        if (do_highlight) event.target.select()
                    }}
                    style={{
                        width: "100%",
                        color: (is_good ? undefined : "red"),
                        borderColor: (is_good ? undefined : "red"),
                    }} />)
            } else {
                value_html = (<input value={this.props.value}
                    onChange={(event) => this.handleUpdate(event)}
                    type={input_type}
                    onFocus={(event) => {
                        if (do_highlight) event.target.select()
                    }}
                    style={{
                        width: width,
                        color: (is_good ? undefined : "red"),
                        borderColor: (is_good ? undefined : "red"),
                    }} />);
            }
        } else {
            value_html = (<span> {this.props.value}</span>);
        }

        return (
            <tr style={this.props.style}>
                {pre_label_html}
                <td>
                    {value_html}
                </td>
                {post_label_html}
            </tr>);
    }

    handleUpdate(event) {
        let value = event.target.value;
        if (this.is_number) {
            value = toNumberOrZero(value);
        } else {
            if (value.length > this.props.maxLength) {
                value = value.substring(0, this.props.maxLength);
            }
        }
        this.props.onChange(value);
    }
}

export class PlanetDependentTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (this.last_request_x !== this.props.x || this.last_request_y !== this.props.y || this.last_request_z !== this.props.z) {
            this._refreshPlanetDetails(this.props.x, this.props.y, this.props.z);
            this.last_request_x = this.props.x;
            this.last_request_y = this.props.y;
            this.last_request_z = this.props.z;
        }

        return this.props.callback(this.state.planet);
    }

    _refreshPlanetDetails(x, y, z) {
        Backend.getPlanetDetails(x, y, z, (res) => {
            // Has already changed
            let planet = res.planet;
            if (planet && (this.props.x !== planet.x || this.props.y !== planet.y || this.props.z !== planet.z)) {
                return;
            }
            this.setState({ planet: planet });
        });
    }
}

export class ResourceNumber extends React.Component {
    render() {
        const decimal_count = this.props.decimal_count === undefined ? 1 : this.props.decimal_count;
        let displayed_value = this.props.number.toFixed(decimal_count);
        if (displayed_value === "0.0" || displayed_value === "-0.0") {
            return (<span>{Number(0).toFixed(decimal_count)}</span>);
        }
        return (<span>{displayed_value}</span>);
    }
}

export class ResourceProductionDelta extends React.Component {
    render() {
        let delta = this.props.delta;
        let displayed_value = delta.toFixed(2);
        if (displayed_value === "0.00" || displayed_value === "-0.00") {
            return (<span>0.00</span>);
        }
        if (delta < 0) {
            return (<span style={{ color: "red" }}>{displayed_value}</span>);
        }
        if (delta > 0) {
            return (<span style={{ color: "green" }}>+{displayed_value}</span>);
        }
        return (<span>{displayed_value}</span>);
    }
}

export class ResourceProductionPercentage extends React.Component {
    render() {
        let percentage = this.props.ratio * 100;
        let displayed_value = (Math.round(percentage * 10) / 10).toFixed(1);
        if (displayed_value === "0.0" || displayed_value === "-0.0") {
            return (<span>0%</span>);
        }
        if (displayed_value === "100.0") {
            return (<span style={{ color: "green" }}>100%</span>);
        }
        return (<span style={{ color: "red" }}>{displayed_value}%</span>);
    }
}

export class DopeButton extends React.Component {
    render() {
        let label = this.props.label;
        let loading = this.props.loading;
        let onClick = this.props.onClick;

        if (loading) {
            return (<button className="dope-button" onClick={onClick} disabled={true}>
                <span className="dope-button--loading">{label}</span>
            </button>
            );
        } else {
            return (<button className="dope-button" onClick={onClick}>
                <span>{label}</span>
            </button>
            );
        }
    }
}

export class Tooltip extends React.Component {
    render() {
        return <div className="dope-tooltip" style={{ textAlign: "center" }}>
            {this.props.children}
            <div className="dope-tooltiptext" style={this.props.tooltipStyle}>
                {this.props.tooltip}
            </div>
        </div>
    }
}

export class ListInToolTip extends React.Component {
    render() {
        const name = this.props.name;
        const properties = this.props.properties;

        return <div>
            {name}
            <table>
                <tbody style={{ fontSize: "13px" }}>
                    {properties.map((prop, idx) => {
                        switch (prop.type) {
                            case "efficiency": {
                                return (<tr key={idx}>
                                    <td style={{ textAlign: "left" }}>{prop.name}</td>
                                    <td style={{ textAlign: "right", color: prop.color }}>{prop.value}</td>
                                </tr>);
                            }
                            case undefined: {
                                return (<tr key={idx}>
                                    <td style={{ textAlign: "left", paddingRight: "20px" }}>{prop.name}</td>
                                    <td style={{ textAlign: "right", color: prop.color }}>
                                        <ShortNumber number={prop.value} />
                                    </td>
                                </tr>);
                            }
                            default: {
                                return (<tr key={idx}>
                                    <td style={{ textAlign: "left", paddingRight: "20px" }}>UNKNOWN TYPE:</td>
                                    <td style={{ textAlign: "right", color: prop.color }}>{prop.type}</td>
                                </tr>);
                            }
                        }
                    })}
                </tbody>
            </table>
        </div>;
    }
}

export class ShortNumber extends React.Component {

    trimDecimals(number) {
        const hide_decimal = this.props.hideDecimals || false;
        const res = Math.floor(number * 10) / 10;
        return res.toFixed(hide_decimal ? 0 : 1).replace('.0', '');
    }

    render() {
        const number = this.props.number;

        switch (true) {
            case (Math.abs(number) < 1e4):
                return <span style={this.props.style}>{this.trimDecimals(number)}</span>
            case (Math.abs(number) < 1e7):
                return <span style={this.props.style}>{this.trimDecimals(number / 1e3)}K</span>
            case (Math.abs(number) < 1e10):
                return <span style={this.props.style}>{this.trimDecimals(number / 1e6)}M</span>
            case (Math.abs(number) < 1e13):
                return <span style={this.props.style}>{this.trimDecimals(number / 1e9)}B</span>
            default:
                return <span style={this.props.style}>{this.trimDecimals(number / 1e12)}T</span>
        }
    }
}

export class NumberWithDecimalSeparators extends React.Component {
    render() {
        const number = this.props.number;
        const reverseString = s => s.split("").reverse().join("");
        const separators_number = reverseString(number.toFixed()).match(/.{1,3}/g).reverse().map(s => reverseString(s)).join(",");
        return <span>{separators_number}</span>
    }
}

// ------------------------------------------------------------------------------------
// Display resource amount with an icon

export class MoneyWithIcon extends React.Component {
    render() {
        let amount = this.props.amount;
        let color = this.props.bad ? "red" : undefined;

        return (
            <span>
                <ShortNumber style={{ color: color }} number={amount} />
                <img style={{ height: "16px", marginLeft: "2px" }} src={ICONS.RESOURCES.money} alt="" />
            </span>
        );
    }
}

export class ResourceWithIcon extends React.Component {
    render() {
        let resource = this.props.resource;
        let amount = this.props.amount;

        return (<span>{resource.ui_name}: {amount}</span>)
    }
}

// ------------------------------------------------------------------------------------
// Utility functions

export const epoch = () => {
    return (new Date()).getTime();
};

export function getPlanetUrl(planet) {
    return '/' + planet.x + '/' + planet.y + '/' + planet.z;
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getRandomFleetName() {
    const getRandomInt = (min, max) => {
        return min + Math.floor(Math.random() * Math.floor(max - min + 1));
    };

    const greek_letters = ["Alpha", "Beta", "Gamma", "Delta", "Epsilon", "Zeta", "Eta", "Theta", "Iota", "Kappa", "Lambda", "Mu", "Nu", "Xi", "Omicron", "Pi", "Rho", "Sigma", "Tau", "Upsilon", "Phi", "Chi", "Psi", "Omega"];
    const colors = ["Aquamarine", "Blue", "Coral", "Cyan", "Goldenrod", "Gray", "Green", "Khaki", "Magenta", "Orange", "Orchid", "Pink", "Purple", "Red", "Salmon", "Turquoise", "Violet", "Yellow"];

    return colors[getRandomInt(0, colors.length - 1)] + " " + greek_letters[getRandomInt(0, greek_letters.length - 1)];
}

export function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function extractCoordinates(obj) {
    return { x: obj.x, y: obj.y, z: obj.z };
}

export function IsNumber(any) {
    return !isNaN(any);
}

export function smartTextToHtml(text, details) {
    return text.split(/([,.:!\s])/).map((item, i) => {
        if (item === "#planet") {
            return (<PlanetLink key={i} planet={details.planet} showOwner={true} />);
        }
        if (item === "#fleet") {
            return (<FleetLink key={i} fleetId={details.fleet_id} fleetName={details.fleet_name} />);
        }
        if (item === "#combat-report") {
            return (<CombatReport key={i} details={details} />);
        }
        if (item === "#resources") {
            return (<ResourcesView key={i} resources={details.resources} />);
        }
        if (item === "#repaired_structure") {
            return (<span>{details.repaired_structure} structure</span>);
        }
        return item;
    });
}

class CombatReport extends React.Component {
    render() {
        let report = this.props.details;

        report.before = {
            ship_count: report.ships.reduce((acc, iter) => acc + iter.before.ship_count, 0),
            structure: report.ships.reduce((acc, iter) => acc + iter.before.structure, 0),
            sustained_damage: report.ships.reduce((acc, iter) => acc + iter.before.sustained_damage, 0),
        }

        report.after = {
            ship_count: report.ships.reduce((acc, iter) => acc + iter.after.ship_count, 0),
            structure: report.ships.reduce((acc, iter) => acc + iter.after.structure, 0),
            sustained_damage: report.ships.reduce((acc, iter) => acc + iter.after.sustained_damage, 0),
        }

        const before_health = report.before.structure - report.before.sustained_damage;
        const after_health = report.after.structure - report.after.sustained_damage;

        return (
            <div>
                <span className="boring-info-text">We lost {report.before.ship_count - report.after.ship_count} ship{report.before.ship_count - report.after.ship_count !== 1 ? "s" : ""} ({before_health - after_health} structure).</span>
                {this.renderOurFleet(report)}
                {this.renderOtherFleets(report)}
            </div>
        );
    }

    renderOurFleet(report) {
        const before_health = report.before.structure - report.before.sustained_damage;
        const after_health = report.after.structure - report.after.sustained_damage;
        const total_effective_damage = report.ships.reduce((acc, iter) => acc + iter.dealt.effective_damage, 0);
        const total_overkill_damage = report.ships.reduce((acc, iter) => acc + iter.dealt.overkill_damage, 0);

        return (
            <table className="resources">
                <thead>
                    <tr>
                        <td>Ship Type</td>
                        <td>Count</td>
                        <td>Lost</td>
                        <td>Structure</td>
                        <td>Lost</td>
                        <td>Damage (overkill)</td>
                    </tr>
                </thead>
                <tbody>
                    { // Row for each ship type
                        Object.entries(report.ships).map(([ship_design_id, iter]) => {
                            const before_health = iter.before.structure - iter.before.sustained_damage;
                            const after_health = iter.after.structure - iter.after.sustained_damage;
                            return (
                                <tr key={ship_design_id}>
                                    <td>
                                        <Link className="link-button" to={"/game/ship-design/" + iter.design_id}>{iter.design_name}</Link>
                                    </td>
                                    <td>
                                        <span>{iter.before.ship_count}</span>
                                    </td>
                                    <td>
                                        {iter.before.ship_count > iter.after.ship_count ? <span style={{ color: "red" }}> -{iter.before.ship_count - iter.after.ship_count}</span> : null}
                                    </td>
                                    <td>
                                        <span>{before_health}</span>
                                    </td>
                                    <td>
                                        {before_health > after_health ? <span style={{ color: "red" }}> -{before_health - after_health}</span> : null}
                                    </td>
                                    <td>
                                        <span>{iter.dealt.effective_damage} ({iter.dealt.overkill_damage})</span>
                                    </td>
                                </tr>
                            )
                        })}
                    <tr key={-1}>
                        <td>Total</td>
                        <td>
                            <span>{report.before.ship_count}</span>
                        </td>
                        <td>
                            {report.before.ship_count > report.after.ship_count ? <span style={{ color: "red" }}> -{report.before.ship_count - report.after.ship_count}</span> : null}
                        </td>
                        <td>
                            <span>{before_health}</span>
                        </td>
                        <td>
                            {before_health > after_health ? <span style={{ color: "red" }}> -{before_health - after_health}</span> : null}
                        </td>
                        <td>
                            <span>{total_effective_damage} ({total_overkill_damage})</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    renderOtherFleets(report) {
        return (
            <table className="resources">
                <thead>
                    <tr>
                        <td>Enemy Fleets</td>
                        <td>Count</td>
                        <td>Lost</td>
                        <td>Structure</td>
                        <td>Lost</td>
                    </tr>
                </thead>
                <tbody>
                    {report.other_fleets.map((fleet, idx) => {
                        const is_friendly = report.player_id === fleet.player_id;
                        const before_health = fleet.before.structure - fleet.before.sustained_damage;
                        const after_health = fleet.after.structure - fleet.after.sustained_damage;
                        return (
                            <tr key={idx}>
                                <td><PlayerLink playerId={fleet.player_id} playerName={fleet.player_name} />'s
                                    fleet {fleet.fleet_id}</td>
                                <td>
                                    <span>{fleet.before.ship_count}</span>
                                </td>
                                <td>
                                    {fleet.before.ship_count > fleet.after.ship_count ? <span style={{ color: (is_friendly ? "red" : "green") }}> -{fleet.before.ship_count - fleet.after.ship_count}</span> : null}
                                </td>
                                <td>
                                    <span>{before_health}</span>
                                </td>
                                <td>
                                    {before_health > after_health ? <span style={{ color: (is_friendly ? "red" : "green") }}> -{before_health - after_health}</span> : null}
                                </td>
                            </tr>)
                    })}
                </tbody>
            </table>
        )
    }
}

export const toNumberOrZero = (value) => {
    if (!Number.isInteger(Number(value)) || value < 0) {
        return 0;
    }
    return Number(value);
};

// ------------------------------------------------------------------------------------
// These functions are used to enable navigation and parameter for my ReactComponents inside of Routers

export const withNavigation = (Component) => {
    return props => <Component {...props} navigate={useNavigate()} />;
}

export const withParams = (Component) => {
    return props => <Component {...props} params={useParams()} />;
}

export const withParamsAndNavigation = (Component) => {
    return props => <Component {...props} params={useParams()} navigate={useNavigate()} />;
}

// ------------------------------------------------------------------------------------
// Real time function .. timings are calculated in the time as in real live

export class RealTime {
    static _prepareElement = (t) => {
        if (t < 10) {
            t = "0" + t;
        }
        return t;
    };

    static timeToTimeComponents(t) {
        let days = Math.floor(t / DAY);
        let hours = Math.floor((t % DAY) / HOUR);
        let minutes = Math.floor((t % HOUR) / MINUTE);
        let seconds = Math.round((t % MINUTE) / SECOND); // The decimal places of the other are handled by the next smaller one, there is nothing smaller than seconds -> use round here
        return { days: days, hours: hours, minutes: minutes, seconds: seconds };
    }

    static timeSpanToHtml(t) {
        let c = RealTime.timeToTimeComponents(t);
        return RealTime.timeComponentsToHtml(c.days, c.hours, c.minutes, c.seconds);
    }

    static timeComponentsToStringOld(days, hours, minutes, seconds) {
        days = RealTime._prepareElement(days);
        hours = RealTime._prepareElement(hours);
        minutes = RealTime._prepareElement(minutes);
        seconds = RealTime._prepareElement(seconds);

        if (days === "00" && hours === "00" && minutes === "00") {
            return Number(seconds);
        }
        if (days === "00" && hours === "00") {
            return Number(minutes) + ":" + seconds;
        }
        if (days === "00") {
            return Number(hours) + ":" + minutes + ":" + seconds;
        }
        return Number(days) + ":" + hours + ":" + minutes + ":" + seconds;
    }

    static timeComponentsToHtml(days, hours, minutes, seconds) {
        // days = RealTime._prepareElement(days);
        // hours = RealTime._prepareElement(hours);
        // minutes = RealTime._prepareElement(minutes);
        // seconds = RealTime._prepareElement(seconds);

        if (days === 0 && hours === 0 && minutes === 0) {
            return <span>{Number(seconds)}<span className="time-digit-descriptors">s</span></span>;
        }
        if (days === 0 && hours === 0) {
            return <span>{Number(minutes)}<span className="time-digit-descriptors">m</span> {seconds}<span
                className="time-digit-descriptors">s</span></span>;
        }
        if (days === 0) {
            return <span>{Number(hours)}<span className="time-digit-descriptors">h</span> {minutes}<span
                className="time-digit-descriptors">m</span> {seconds}<span
                    className="time-digit-descriptors">s</span></span>;
        }
        return <span>{Number(days)}<span className="time-digit-descriptors">d</span> {hours}<span
            className="time-digit-descriptors">h</span> {minutes}<span
                className="time-digit-descriptors">m</span></span>;
    }

    static timeOfDay(now) {
        return ((now.getHours() < 10) ? "0" : "") + now.getHours() + ":" + ((now.getMinutes() < 10) ? "0" : "") + now.getMinutes() + ":" + ((now.getSeconds() < 10) ? "0" : "") + now.getSeconds();
    }

    static timePointToHtml(t) {
        const event = new Date(t);
        const now = new Date();
        if (event.getDate() === now.getDate() && event.getMonth() === now.getMonth() && event.getFullYear() === now.getFullYear()) {
            return (<span>Today, {RealTime.timeOfDay(event)}</span>);
        }
        now.setDate(now.getDate() + 1);
        if (event.getDate() === now.getDate() && event.getMonth() === now.getMonth() && event.getFullYear() === now.getFullYear()) {
            return (<span>Tomorrow, {RealTime.timeOfDay(event)}</span>);
        }
        return (<span>{event.toLocaleString()}</span>)
    }
}

// ------------------------------------------------------------------------------------
// In game time functions .. the time is calculated with the time factor of the game (not really implemented)

export class InGameTime {

    // dob := Date of birth in years since genesis of the universe
    static getAge(dob) {
        return epoch() + dob;
    }

    static getAgeAsNiceString(dob) {
        return this.ageToNiceString(this.getAge(dob));
    }

    static ageToNiceString(age) {
        if (age > YEAR * BILLION) {
            let val = age / YEAR / BILLION;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " billion years";
        }
        if (age > YEAR * MILLION) {
            let val = age / YEAR / MILLION;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " million years";
        }
        if (age > YEAR * THOUSAND) {
            let val = age / YEAR / THOUSAND;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " thousand years";
        }
        if (age > YEAR) {
            let val = age / YEAR;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " years";
        }
        if (age > DAY) {
            let val = age / DAY;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " days";
        }
        if (age > HOUR) {
            let val = age / HOUR;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " hours";
        }
        if (age > MINUTE) {
            let val = age / MINUTE;
            return Math.floor(val) + "." + Math.floor((val - Math.floor(val)) * 10) + " minutes";
        }
        return age + " seconds";
    }
}
